import React, { Component } from "react";
import { Table, List } from "semantic-ui-react";
import _ from "lodash";
import pickDeep from "../../../utils/nodeUtil";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import { getFormattedPhone } from "../../common/Phone";

class PhoneDetail extends Component {
  state = {
    phoneNodes: [],
  };

  componentDidMount() {
    this.loadPhones(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadPhones(nextProps);
  }

  loadPhonesForGolodAndPlatinumReport = (props) => {
    const addressList = _.get(props.node, "addresses[0].address");
    const updatedAddresses = [];
    _.forEach(addressList, (address) => {
      const dateTo = _.get(address, "dateTo[0]._");
      if (dateTo !== undefined) {
        const tokens = dateTo.split("/");
        if (tokens.length > 1) {
          address.dateToUpdatedRaw = `${tokens[1]}${tokens[0]}`;
        }
        updatedAddresses.push(address);
      }
    });
    const orderedAddressList = _.orderBy(
      updatedAddresses,
      ["dateToUpdatedRaw"],
      ["desc"]
    );
    const enhancedPhoneGroupNodes = [];
    pickDeep(
      orderedAddressList[0],
      "enhancedPhoneInfo",
      enhancedPhoneGroupNodes
    );
    const phoneNodes = [];

    if (enhancedPhoneGroupNodes.length > 0) {
      const phoneInfos = [];
      const phoneInfos1 = _.get(orderedAddressList[0], "phones[1].phoneInfo");
      pickDeep(orderedAddressList[0], "phoneInfo", phoneInfos);
      _.forEach(
        _.flatten(enhancedPhoneGroupNodes),
        (enhancedPhoneGroupNode, index) => {
          const phoneInfo1 = _.filter(
            phoneInfos1,
            (a) =>
              _.get(a, "phone[0]._") ===
              _.get(enhancedPhoneGroupNode, "phone10[0]._", "")
          );
          const indicatorNodes = [];
          const risks = [];
          pickDeep(enhancedPhoneGroupNode, "highRiskIndicator", indicatorNodes);
          if (phoneInfo1 !== undefined && phoneInfo1.length > 0) {
            phoneNodes.push(
              <Table.Row
                key={`phone_row_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={4} className="text-bold">
                  Phone
                </Table.Cell>
                <Table.Cell width={5}>
                  {_.get(phoneInfo1[0], "phone[0]._", "")}
                </Table.Cell>
                <Table.Cell width={3} className="text-bold">
                  Type
                </Table.Cell>
                <Table.Cell width={4}>
                  {_.get(phoneInfo1[0], "providerType[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );
          } else {
            phoneNodes.push(
              <Table.Row
                key={`phone_row_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell colSpan={4}>
                  Phone: {_.get(enhancedPhoneGroupNode, "phone10[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );
          }
          const listedName = _.get(
            enhancedPhoneGroupNode,
            "listedName[0]._",
            ""
          );
          if (listedName !== "") {
            phoneNodes.push(
              <Table.Row
                key={`phone_listedname_row_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={9} colSpan={2} className="text-bold">
                  Listed Name:
                </Table.Cell>
                <Table.Cell width={7} colSpan={2}>
                  {listedName}
                </Table.Cell>
              </Table.Row>
            );
          }
          if (phoneInfo1 !== undefined) {
            phoneNodes.push(
              <Table.Row
                key={`phone_carrier_row_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell colSpan={4}>
                  <span className="text-bold">Carrier: </span>
                  {_.get(phoneInfo1[0], "phoneCarrier[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );
          }
          const riskNodes = [];
          _.forEach(_.flatten(indicatorNodes), (indicatorNode, subIndex) => {
            risks.push(_.get(indicatorNode, "description[0]._", ""));
            riskNodes.push(
              <List.Item key={`risk_det_${index}_${subIndex}`}>
                {_.get(indicatorNode, "description[0]._", "")}
              </List.Item>
            );
          });
          phoneNodes.push(
            <Table.Row
              key={`phone_Risk_row_${index}`}
              className={index % 2 === 1 ? "table-row-odd-child" : ""}
            >
              <Table.Cell colSpan={4}>
                <span className="text-bold"> High Risk Indicators: </span>
                <List>{riskNodes}</List>
              </Table.Cell>
            </Table.Row>
          );
        }
      );
    } else {
      _.forEach(orderedAddressList, (orderedAddress, ordAddIndex) => {
        const phoneInfos = [];
        pickDeep(orderedAddress, "phoneInfo", phoneInfos);
        _.forEach(_.flatten(phoneInfos), (phoneInfo, index) => {
          const phone = _.get(phoneInfo, "phone[0]._", "");
          const phoneType = _.get(phoneInfo, "phoneType[0]._", "");
          if (phone !== "" && phoneType !== "") {
            phoneNodes.push(
              <Table.Row
                key={`phone_row_${ordAddIndex}${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={4} className="text-bold">
                  Phone
                </Table.Cell>
                <Table.Cell width={5}>{phone}</Table.Cell>
                <Table.Cell width={3} className="text-bold">
                  Type
                </Table.Cell>
                <Table.Cell width={4}>{phoneType}</Table.Cell>
              </Table.Row>
            );
            if (
              this.props.displayCarrier &&
              this.props.displayCarrier === true
            ) {
              phoneNodes.push(
                <Table.Row
                  key={`phone_carrier_row_${ordAddIndex}_${index}`}
                  className={index % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell width={4} colSpan={2} className="text-bold">
                    Carrier
                  </Table.Cell>
                  <Table.Cell colSpan={2} width={5}>
                    {_.get(phoneInfo, "phoneCarrier[0]._", "")}
                  </Table.Cell>
                </Table.Row>
              );
            }
          }
        });
      });
    }
    this.setState({ phoneNodes });
  };

  loadPhonesForSilverReport = (props) => {
    const phones = _.get(props.node, "phones[0].phone");
    const phoneNodes = [];
    if (phones) {
      _.forEach(phones, (phone, index) => {
        phoneNodes.push(
          <Table.Row
            key={`phone_row_${index}`}
            className={index % 2 === 1 ? "table-row-odd-child" : ""}
          >
            <Table.Cell width={4} className="text-bold">
              Phone
            </Table.Cell>
            <Table.Cell width={5}>
              {getFormattedPhone(_.get(phone, "phoneNumber[0]._", ""))}
            </Table.Cell>
            <Table.Cell width={3} className="text-bold">
              Type
            </Table.Cell>
            <Table.Cell width={4}>
              {_.get(phone, "phoneType[0]._", "")}
            </Table.Cell>
          </Table.Row>
        );
        phoneNodes.push(
          <Table.Row
            key={`phone_carrier_row_${index}`}
            className={index % 2 === 1 ? "table-row-odd-child" : ""}
          >
            <Table.Cell colSpan={4}>
              <span className="text-bold">Carrier: </span>
              {_.get(phone, "carrier[0]._", "")}
            </Table.Cell>
          </Table.Row>
        );
      });
    }
    this.setState({ phoneNodes });
  };

  loadPhones = (props) => {
    const { isSilverReport } = props;
    if (!isSilverReport) {
      this.loadPhonesForGolodAndPlatinumReport(props);
    } else {
      this.loadPhonesForSilverReport(props);
    }
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Current Phone"}
        rows={this.state.phoneNodes}
      />
    );
  }
}

export default PhoneDetail;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/PhoneDetail.js